export const ALL_COUNTRIES_TIMEZONES = [
  // -------------------------
  // UNITED STATES (USA)
  // -------------------------
  { value: 'America/New_York', label: 'New York, NY', offset: 'UTC-5' },
  { value: 'America/Detroit', label: 'Detroit, MI', offset: 'UTC-5' },
  { value: 'America/Chicago', label: 'Chicago, IL', offset: 'UTC-6' },
  {
    value: 'America/Indiana/Indianapolis',
    label: 'Indianapolis, IN',
    offset: 'UTC-5',
  },
  { value: 'America/Denver', label: 'Denver, CO', offset: 'UTC-7' },
  { value: 'America/Phoenix', label: 'Phoenix, AZ', offset: 'UTC-7' },
  { value: 'America/Los_Angeles', label: 'Los Angeles, CA', offset: 'UTC-8' },
  { value: 'America/Anchorage', label: 'Anchorage, AK', offset: 'UTC-9' },
  { value: 'America/Adak', label: 'Adak, AK', offset: 'UTC-10' },
  { value: 'Pacific/Honolulu', label: 'Honolulu, HI', offset: 'UTC-10' },

  // -------------------------
  // EUROPE
  // -------------------------
  { value: 'Europe/London', label: 'London, United Kingdom', offset: 'UTC+0' },
  { value: 'Europe/Lisbon', label: 'Lisbon, Portugal', offset: 'UTC+0' },

  { value: 'Europe/Paris', label: 'Paris, France', offset: 'UTC+1' },
  { value: 'Europe/Berlin', label: 'Berlin, Germany', offset: 'UTC+1' },
  { value: 'Europe/Madrid', label: 'Madrid, Spain', offset: 'UTC+1' },
  { value: 'Europe/Rome', label: 'Rome, Italy', offset: 'UTC+1' },
  {
    value: 'Europe/Amsterdam',
    label: 'Amsterdam, Netherlands',
    offset: 'UTC+1',
  },
  { value: 'Europe/Brussels', label: 'Brussels, Belgium', offset: 'UTC+1' },

  { value: 'Europe/Athens', label: 'Athens, Greece', offset: 'UTC+2' },
  { value: 'Europe/Bucharest', label: 'Bucharest, Romania', offset: 'UTC+2' },
  { value: 'Europe/Helsinki', label: 'Helsinki, Finland', offset: 'UTC+2' },

  { value: 'Europe/Moscow', label: 'Moscow, Russia', offset: 'UTC+3' },

  // -------------------------
  // MIDDLE EAST
  // -------------------------
  {
    value: 'Asia/Dubai',
    label: 'Dubai, United Arab Emirates',
    offset: 'UTC+4',
  },
  { value: 'Asia/Qatar', label: 'Doha, Qatar', offset: 'UTC+3' },
  { value: 'Asia/Riyadh', label: 'Riyadh, Saudi Arabia', offset: 'UTC+3' },

  // -------------------------
  // SOUTH ASIA
  // -------------------------
  { value: 'Asia/Karachi', label: 'Karachi, Pakistan', offset: 'UTC+5' },
  { value: 'Asia/Kolkata', label: 'Kolkata, India', offset: 'UTC+5:30' },
  { value: 'Asia/Kathmandu', label: 'Kathmandu, Nepal', offset: 'UTC+5:45' },
  { value: 'Asia/Dhaka', label: 'Dhaka, Bangladesh', offset: 'UTC+6' },

  // -------------------------
  // SOUTHEAST ASIA
  // -------------------------
  { value: 'Asia/Bangkok', label: 'Bangkok, Thailand', offset: 'UTC+7' },
  { value: 'Asia/Jakarta', label: 'Jakarta, Indonesia', offset: 'UTC+7' },

  { value: 'Asia/Shanghai', label: 'Shanghai, China', offset: 'UTC+8' },
  { value: 'Asia/Singapore', label: 'Singapore, Singapore', offset: 'UTC+8' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong, China', offset: 'UTC+8' },
  {
    value: 'Asia/Kuala_Lumpur',
    label: 'Kuala Lumpur, Malaysia',
    offset: 'UTC+8',
  },

  // -------------------------
  // EAST ASIA
  // -------------------------
  { value: 'Asia/Tokyo', label: 'Tokyo, Japan', offset: 'UTC+9' },
  { value: 'Asia/Seoul', label: 'Seoul, South Korea', offset: 'UTC+9' },

  // -------------------------
  // OCEANIA
  // -------------------------
  {
    value: 'Australia/Brisbane',
    label: 'Brisbane, Australia',
    offset: 'UTC+10',
  },
  { value: 'Australia/Sydney', label: 'Sydney, Australia', offset: 'UTC+11' },

  {
    value: 'Pacific/Auckland',
    label: 'Auckland, New Zealand',
    offset: 'UTC+13',
  },

  // -------------------------
  // LATIN AMERICA
  // -------------------------
  {
    value: 'America/Mexico_City',
    label: 'Mexico City, Mexico',
    offset: 'UTC-6',
  },
  { value: 'America/Bogota', label: 'Bogotá, Colombia', offset: 'UTC-5' },
  { value: 'America/Lima', label: 'Lima, Peru', offset: 'UTC-5' },
  { value: 'America/Santiago', label: 'Santiago, Chile', offset: 'UTC-4' },
  { value: 'America/Sao_Paulo', label: 'São Paulo, Brazil', offset: 'UTC-3' },
];

export const DEFAULT_TIMEZONE = 'UTC';

export const TIMEZONE_FORMATS = {
  SHORT: 'zzz', // EST, PST
  LONG: 'zzzz', // Eastern Standard Time
  OFFSET: 'xxx', // -05:00
  OFFSET_SHORT: 'xx', // -0500
} as const;
